/**
 * Group flat hydrated results into one entry per property.
 *
 * Measured on the live collection: a single location took 21 of 50 slots (42%
 * of the page), another took 8. For location scouting the unit of interest is
 * the property, not the photo — 21 angles of one house is one result, not 21.
 *
 * Grouped on `location_id`, which hydrateResults() sets from the DATABASE
 * model rather than the index record. That matters: a stale index row would
 * otherwise file a photo under the wrong property while showing the right
 * slug and title, so it would look perfectly correct.
 *
 * `matchCount` is derived here, after the server has already dropped
 * non-public locations — never stored — so it can't go stale when a location
 * is unpublished.
 *
 * Order is preserved from the server (ascending distance), so the first image
 * seen for a location is its best match and becomes the cover, and groups come
 * out ranked by their best match without re-sorting.
 */
export default function groupResults(results) {
    if (!Array.isArray(results)) return [];

    const groups = [];
    const byLocation = new Map();

    results.forEach((result) => {
        // Fall back to the media id so a record with no location still renders
        // as its own card rather than silently vanishing.
        const key = result.location_id != null ? result.location_id : "media-" + result._id;
        let group = byLocation.get(key);

        if (!group) {
            group = {
                key,
                location: result.location,
                slug: result.slug,
                images: [],
                bestDistance: result._distance,
            };
            byLocation.set(key, group);
            groups.push(group);
        }

        group.images.push(result);
    });

    groups.forEach((group) => {
        group.cover = group.images[0];
        group.matchCount = group.images.length;
    });

    return groups;
}
